import DescriptionIcon from '@material-ui/icons/Description';

import PostList from './PostList';
import PostEdit from './PostEdit';
import PostCreate from './PostCreate';

export default {
    list: PostList,
    edit: PostEdit,
    create: PostCreate,
    icon: DescriptionIcon,
};
